var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.routeObj)?_c('span',[_vm._t("default")],2):_c('span')
}
var staticRenderFns = []

export { render, staticRenderFns }